import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PagedData } from '../models/BaseResponse';
import { ReportTemplate, ReportTemplateVar } from '../models/ReportTemplate';
import { ReportTemplateSearchCriteria } from '../models/searchCriteria/ReportTemplateSearchCriteria';

@Injectable({
  providedIn: 'root'
})
export class ReportTemplateService {


  constructor(private httpClient: HttpClient) { }

  find(searchCriteria: ReportTemplateSearchCriteria): Observable<PagedData<ReportTemplate>> {
    return this.httpClient.post<PagedData<ReportTemplate>>(environment.apiUrl + "report-templates/filtered",searchCriteria);
  }

  get(id: number): Observable<ReportTemplate> {
    return this.httpClient.get<ReportTemplate>(environment.apiUrl + "report-templates/" + id);
  }

  save(reportTemplate: ReportTemplate): Observable<void> {
    if (reportTemplate.id == 0 || reportTemplate.id === undefined) {
      return this.httpClient.post<void>(environment.apiUrl + "report-templates", reportTemplate);
    }
    else {
      return this.httpClient.put<void>(environment.apiUrl + "report-templates/" + reportTemplate.id, reportTemplate);
    }
  }
 
  delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(environment.apiUrl + "report-templates/" + id);
  }

  findAllVars(): Observable<ReportTemplateVar[]> {
    return this.httpClient.get<ReportTemplateVar[]>(environment.apiUrl + "report-template-vars");
  }

}  